import { ApiService, ApiServiceInterface } from "../../../../../core";
import { AdsStatementDataResponse, AdsStatementUnsubscribeResponse } from "../../../site/interfaces";
import { AdsStatementPageController } from "../../core";

export class AdsStatementPageControllerImpl implements AdsStatementPageController {
    private api: ApiServiceInterface;

    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async onLoad(): Promise<AdsStatementDataResponse> {
        try {
            const response = await this.api.get('/ads-user');
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async showBankSlip(id: string): Promise<AdsStatementDataResponse> {
        try {
            const response = await this.api.get(`/subscription-user-bank-slip/${id}`);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async updateAds(status: string, id: string): Promise<AdsStatementDataResponse> {
        try {
            const requestData = {};
            requestData['id'] = id;
            requestData['status'] = status;

            const response = await this.api.put(`/payment-update-status`, requestData);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }

    async cancelAds(id: string, reason: string): Promise<AdsStatementUnsubscribeResponse> {
        try {
            const requestData = {};
            requestData['id'] = id;
            requestData['reason'] = reason;

            const response = await this.api.put(`/unsubscribe`, requestData);
            return response;
        } catch (error) {
            throw new Error("Method not implemented.");
        }
    }
}